import TPhoneBookAddByUploadingFile from './index.vue';

TPhoneBookAddByUploadingFile.install = app => {
  app.component(TPhoneBookAddByUploadingFile.name, TPhoneBookAddByUploadingFile);
};

export default TPhoneBookAddByUploadingFile;
